export default function SearchIcon({ variant = "outlined" }) {
  return (
    variant === "outlined" ? (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.75 21C16.9967 21 21.25 16.7467 21.25 11.5C21.25 6.25329 16.9967 2 11.75 2C6.50329 2 2.25 6.25329 2.25 11.5C2.25 16.7467 6.50329 21 11.75 21Z"
          stroke="#8A8A8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.25 22L20.25 20" stroke="#8A8A8A" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
      </svg>
    ) : (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.75 21C16.9967 21 21.25 16.7467 21.25 11.5C21.25 6.25329 16.9967 2 11.75 2C6.50329 2 2.25 6.25329 2.25 11.5C2.25 16.7467 6.50329 21 11.75 21Z"
          stroke="#560BA2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.25 22L20.25 20" stroke="#BB9DDA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  )
}
